import { render, staticRenderFns } from "./DataManagementAdd.vue?vue&type=template&id=31367649&scoped=true&"
import script from "./DataManagementAdd.vue?vue&type=script&lang=js&"
export * from "./DataManagementAdd.vue?vue&type=script&lang=js&"
import style0 from "./DataManagementAdd.vue?vue&type=style&index=0&id=31367649&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31367649",
  null
  
)

export default component.exports